/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTag as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { UseSwitchCommon } from './hooks';
import UTable from '@ultra/share/components/UTable/index.vue';
import ConfForbidden from './modules/confForbidden.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'forbidden',
  setup(__props) {
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道',
      prop: 'cname'
    }, {
      label: '注册',
      prop: 'status_0',
      slot: 'status_0'
    }, {
      label: '登录',
      prop: 'status_1',
      slot: 'status_1'
    }, {
      label: '支付',
      prop: 'status_2',
      slot: 'status_2'
    }, {
      label: '签名校验  ',
      prop: 'status_6',
      slot: 'status_6'
    }, {
      label: '支付校验',
      prop: 'status_8',
      slot: 'status_8'
    }, {
      label: '操作',
      action: true
    }];
    const confForbiddenRef = ref();
    const {
      tableData,
      tableLoading,
      gid,
      filter,
      getTableData,
      switchType
    } = UseSwitchCommon();
    const handleClick = item => {
      confForbiddenRef.value.show({
        data: item
      });
    };
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_tag = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_game_channel_select, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            clearable: "",
            gid: _unref(gid),
            onChange: _unref(getTableData)
          }, null, 8, ["modelValue", "gid", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        pagination: ""
      }, {
        status_0: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_0, 0).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_0, 0).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        status_1: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_1, 1).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_1, 1).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        status_2: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_2, 2).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_2, 2).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        status_6: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_6, 6).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_6, 6).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        status_8: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_8, 8).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_8, 8).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("配置")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading"]), _createVNode(ConfForbidden, {
        ref_key: "confForbiddenRef",
        ref: confForbiddenRef,
        onSuccess: _unref(getTableData)
      }, null, 8, ["onSuccess"])], 64);
    };
  }
});